import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "1 1 auto",
		marginLeft: "auto",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		justifyContent: "flex-end",
		"& > *": {
			margin: theme.spacing(1),
		},
		[theme.breakpoints.down("sm")]: {
			justifyContent: "flex-start",
			flexWrap: "nowrap",
			overflowX: "auto",
			"&::-webkit-scrollbar": { display: "none" },
			msOverflowStyle: "none",
			scrollbarWidth: "none",
			"& > *": {
				margin: theme.spacing(0.5),
				whiteSpace: "nowrap",
				flexShrink: 0
			}
		}
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
